import React from 'react';
import { connect } from 'react-redux';
import { TextField, Button } from '@devfolioco/genesis';

import { updateName } from 'actions/user';
import { ACTION_STATUS as STATUS } from '@constants';

class Names extends React.PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      firstName: '',
      lastName: '',
    };
  }

  handleInputChange = ({ target: { name, value } }) => {
    this.setState({
      [name]: value,
    });
  };

  handleSubmit = event => {
    event.preventDefault();
    const { dispatchUpdateName } = this.props;
    const { firstName, lastName } = this.state;
    dispatchUpdateName(firstName, lastName);
  };

  render() {
    const { updateNameStatus } = this.props;
    const { firstName, lastName } = this.state;

    return (
      <form onSubmit={this.handleSubmit}>
        <TextField
          label="First Name"
          autoFocus
          maxLength="20"
          name="firstName"
          value={firstName}
          onChange={this.handleInputChange}
          required
          type="text"
        />
        <TextField
          label="Last Name"
          appearance="normal"
          maxLength="20"
          name="lastName"
          value={lastName}
          onChange={this.handleInputChange}
          required
          type="text"
        />
        <Button stretch type="submit" size="large" loading={updateNameStatus === STATUS.REQUEST}>
          Continue
        </Button>
      </form>
    );
  }
}
const mapStateToProps = ({ user }) => ({
  updateNameStatus: user.status.updateName,
});

const mapDispatchToProps = dispatch => ({
  dispatchUpdateName: (firstName, lastName) => {
    dispatch(updateName(firstName, lastName));
  },
});

export default connect(mapStateToProps, mapDispatchToProps)(Names);
